import { useDisclosure } from '@ds';
import { ReactElement, ReactNode } from 'react';
import { ConfirmDetachModal } from '@features/components/CaseOverview/components/AssignedResources/ConfirmDetachModal';

type ChildrenProps = {
  onOpenChange: () => void;
};

type AssignedResourceWithModalProps = {
  isPending: boolean;
  photo: string;
  name: string;
  onDetachSubmit: () => void;
  children: ReactNode | ((props: ChildrenProps) => ReactElement | void);
};

export const WithDetachResourceModal = ({
  children,
  photo,
  name,
  isPending,
  onDetachSubmit,
}: AssignedResourceWithModalProps) => {
  const { isOpen, onOpenChange } = useDisclosure();
  return (
    <>
      {typeof children === 'function' ? children({ onOpenChange }) : children}
      {isOpen && (
        <ConfirmDetachModal
          isPending={isPending}
          onSubmit={onDetachSubmit}
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          photo={photo}
          name={name}
        />
      )}
    </>
  );
};
